export enum ItemTypes {
  Stock = 'Stock',
  Grade = 'Grade',
  Service = 'Service',
  Alteration = 'Alteration',
  Fee = 'Fee',
  FeeRefund = 'FeeRefund',
  Deposit = 'Deposit',
  DepositRefund = 'DepositRefund',
  Tare = 'Tare',
  Collection = 'Collection',
  Warranty = 'Warranty',
  Activation = 'Activation',
  Kit = 'Kit',
  CarWashToken = 'CarWashToken',
  Donation = 'Donation',
}
